import { render, staticRenderFns } from "./activar-cuenta.vue?vue&type=template&id=5e8a11be&scoped=true"
import script from "./activar-cuenta.vue?vue&type=script&lang=js"
export * from "./activar-cuenta.vue?vue&type=script&lang=js"
import style0 from "./activar-cuenta.vue?vue&type=style&index=0&id=5e8a11be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8a11be",
  null
  
)

export default component.exports